import { setRemoteDefinitions } from '@nx/angular/mf';
import { getRemoteDefinitions } from 'shared/utilities/scripts/remote-definitions';

const remotes = {
  'ov-dashboard-ui': 4201,
  'ov-reports-ui': 4202,
  'ov-settings-ui': 4203,
  'ov-comms-ui': 4204,
  'ov-tasks-ui': 4205,
  'ov-invoice-and-attestation-ui': 4206,
  'ov-orders-ui': 4207,
  'ov-dialysis-schedule-ui': 4208,
  'ov-patient-metrics-ui': 4209,
  'ov-patient-care-ui': 4210,
} as const;

const options = {
  hostLocalPort: '4300',
} as const;

const remoteDefinitions = getRemoteDefinitions(window.location, remotes, options);
setRemoteDefinitions(remoteDefinitions);
import('./bootstrap').catch(console.error);
